import React, { useState } from 'react';
import { DEFAULT_PIPE_COMBOS, DEFAULT_SQUARE_PIPE_COMBOS, DEFAULT_SQUARE_SHEET_COMBOS, SQUARE_PROFILE_DISPLAY_SIZE, SQUARE_SHEET_DISPLAY_SIZE } from './pipeCatalog';
import PipeSelectionDialog from './PipeSelectionDialog';

const ContextMenu = ({ x, y, onTransformClick, objectType, onRotateAroundAxis, onRotateSelf, onSelectPipe, objectId, prices, hasSelfFacing, isSelfFacing }) => {
  const style = {
    position: 'absolute',
    top: y,
    left: x,
    zIndex: 1000,
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    boxShadow: 'none',
  };

  const menuItemStyle = {
    padding: '0.5rem 0.75rem', // 8px 12px
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#f0f0f0',
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onTransformClick();
  };

  const [showRotateSubmenu, setShowRotateSubmenu] = useState(false);
  const [showPipeSubmenu, setShowPipeSubmenu] = useState(false);
  const [showSquareSubmenu, setShowSquareSubmenu] = useState(false);
  const [showRoundSubmenu, setShowRoundSubmenu] = useState(false);
  const [showSquareProfileSubmenu, setShowSquareProfileSubmenu] = useState(false);
  const [showSquareSheetSubmenu, setShowSquareSheetSubmenu] = useState(false);
  
  // Доступные варианты труб из Excel (pipePrices) или дефолтного словаря
  const availablePipeKeys = (prices && prices.pipePrices) ? Object.keys(prices.pipePrices) : Object.keys(DEFAULT_PIPE_COMBOS || {});
  const availableSquarePipeKeys = (prices && prices.pipePrices) ? Object.keys(prices.pipePrices).filter(k => k.startsWith('SQUARE_PROFILE|')) : Object.keys(DEFAULT_SQUARE_PIPE_COMBOS || {});
  const availableSquareSheetKeys = (prices && prices.pipePrices) ? Object.keys(prices.pipePrices).filter(k => k.startsWith('SQUARE_SHEET|')) : Object.keys(DEFAULT_SQUARE_SHEET_COMBOS || {});
  
  // Разбираем ключи вида diameter|thickness|coating для круглых труб
  const roundMap = {};
  availablePipeKeys.forEach((k) => {
    const [d, t, c] = k.split('|');
    if (!d || d.startsWith('SQUARE')) return;
    if (!roundMap[d]) roundMap[d] = { thickness: new Set(), coating: new Set() };
    if (t && t !== '-') roundMap[d].thickness.add(t);
    if (c && c !== '-') roundMap[d].coating.add(c);
  });
  const roundDiameters = Object.keys(roundMap).length > 0 ? Object.keys(roundMap).sort((a,b)=>parseFloat(a)-parseFloat(b)) : ["42.4","60.3","76.1","88.9","101.6"];
  
  // Разбираем ключи вида SQUARE_PROFILE|профиль|толщина|покрытие для квадратных труб (профиль)
  const squareProfileMap = {};
  availableSquarePipeKeys.forEach((k) => {
    const [prefix, profile, thickness, coating] = k.split('|');
    if (prefix !== 'SQUARE_PROFILE' || !profile) return;
    if (!squareProfileMap[profile]) squareProfileMap[profile] = { thickness: new Set(), coating: new Set() };
    if (thickness && thickness !== '-') squareProfileMap[profile].thickness.add(thickness);
    if (coating && coating !== '-') squareProfileMap[profile].coating.add(coating);
  });
  const squareProfiles = Object.keys(squareProfileMap).length > 0 ? Object.keys(squareProfileMap).sort((a,b) => {
    const sizeA = SQUARE_PROFILE_DISPLAY_SIZE[a] || 0;
    const sizeB = SQUARE_PROFILE_DISPLAY_SIZE[b] || 0;
    return sizeA - sizeB;
  }) : ['20x20', '25x25', '40x40', '50x50', '60x30', '60x60', '80x40', '80x80', '100x100', '150x150'];
  
  // Разбираем ключи вида SQUARE_SHEET|лист|толщина|покрытие для квадратных труб (лист)
  const squareSheetMap = {};
  availableSquareSheetKeys.forEach((k) => {
    const [prefix, sheet, thickness, coating] = k.split('|');
    if (prefix !== 'SQUARE_SHEET' || !sheet) return;
    if (!squareSheetMap[sheet]) squareSheetMap[sheet] = { thickness: new Set(), coating: new Set() };
    if (thickness && thickness !== '-') squareSheetMap[sheet].thickness.add(thickness);
    if (coating && coating !== '-') squareSheetMap[sheet].coating.add(coating);
  });
  const squareSheets = Object.keys(squareSheetMap).length > 0 ? Object.keys(squareSheetMap).sort((a,b) => {
    const sizeA = SQUARE_SHEET_DISPLAY_SIZE[a] || 0;
    const sizeB = SQUARE_SHEET_DISPLAY_SIZE[b] || 0;
    return sizeA - sizeB;
  }) : ['60x30', '80x40'];
  
  // Состояние для диалога выбора параметров трубы
  const [pipeDialog, setPipeDialog] = useState({
    open: false,
    type: null, // 'round', 'square-profile', 'square-sheet'
    size: null,
    coatings: [],
    thicknesses: [],
    defaultCoating: null,
    defaultThickness: null,
  });

  if (objectType !== 'cylinder' && objectType !== 'fitting') return null;

  return (
    <div 
      style={style}
      onClick={e => e.stopPropagation()}
    >
      {/* Кнопка Поворот только для фитингов, которые ещё не повёрнуты "на себя" */}
      {objectType === 'fitting' && !isSelfFacing && (
        <div
          style={{ position: 'relative', display: 'block' }}
          onMouseEnter={() => setShowRotateSubmenu(true)}
          onMouseLeave={() => setShowRotateSubmenu(false)}
        >
          <div 
            style={{
              ...menuItemStyle,
              display: 'inline-flex',
              alignItems: 'center',
              width: 'max-content',
              border: '0.0625rem solid #cccccc',
              borderRadius: '0.25rem',
              backgroundColor: '#ffffff'
            }}
            onClick={handleClick}
          >
            Поворот
          </div>
          {showRotateSubmenu && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: '100%',
                backgroundColor: 'white',
                border: '0.0625rem solid gray',
                borderRadius: '0.1875rem', // 3px
                padding: '0.3125rem', // 5px
                boxShadow: '0.125rem 0.125rem 0.3125rem rgba(0,0,0,0.2)', // 2px 2px 5px
                minWidth: '11.25rem', // 180px
                zIndex: 1001,
              }}
              onClick={e => e.stopPropagation()}
            >
              <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Поворот</div>
              <div
                style={menuItemStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof onRotateAroundAxis === 'function') onRotateAroundAxis();
                }}
              >
                вокруг своей оси
              </div>
              {hasSelfFacing && (
                <div
                  style={menuItemStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (typeof onRotateSelf === 'function') onRotateSelf();
                  }}
                >
                  на себя
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {objectType === 'cylinder' && (
        <div
          style={{ position: 'relative', display: 'block', marginTop: 6 }}
          onMouseEnter={() => setShowPipeSubmenu(true)}
          onMouseLeave={() => { 
            setShowPipeSubmenu(false); 
            setShowSquareSubmenu(false); 
            setShowRoundSubmenu(false);
            setShowSquareProfileSubmenu(false);
            setShowSquareSheetSubmenu(false);
          }}
        >
          <div
            style={{
              ...menuItemStyle,
              display: 'inline-flex',
              alignItems: 'center',
              width: 'max-content',
              border: '0.0625rem solid #cccccc',
              borderRadius: '0.25rem',
              backgroundColor: '#ffffff'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            Труба ▶
          </div>
          {showPipeSubmenu && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: '100%',
                backgroundColor: 'white',
                border: '0.0625rem solid gray',
                borderRadius: '0.1875rem', // 3px
                padding: '0.3125rem', // 5px
                boxShadow: '0.125rem 0.125rem 0.3125rem rgba(0,0,0,0.2)', // 2px 2px 5px
                minWidth: '11.25rem', // 180px
                zIndex: 1001,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Труба</div>
              <div
                style={menuItemStyle}
                onMouseEnter={() => { 
                  setShowRoundSubmenu(true); 
                  setShowSquareSubmenu(false);
                }}
              >
                Круглая ▶
              </div>
              {showRoundSubmenu && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    backgroundColor: 'white',
                    border: '1px solid gray',
                    borderRadius: '3px',
                    padding: '5px',
                    boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
                minWidth: '10rem', // 160px
                maxHeight: '25rem', // 400px
                    overflowY: 'auto',
                    zIndex: 1002,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Круглая</div>
                  {roundDiameters.map((d) => (
                    <div
                      key={`round-${d}`}
                      style={{ ...menuItemStyle, position: 'relative' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        const coatings = Array.from(roundMap[d]?.coating || []);
                        const thicknesses = Array.from(roundMap[d]?.thickness || []).sort((a,b)=>parseFloat(a.replace('x',''))-parseFloat(b.replace('x','')));
                        
                        // Формируем список валидных комбинаций из каталога
                        const validCombinations = [];
                        availablePipeKeys.forEach((k) => {
                          const [diameter, thickness, coating] = k.split('|');
                          if (diameter === d && thickness && coating) {
                            validCombinations.push({ thickness, coating });
                          }
                        });
                        
                        // Определяем дефолтные значения с учетом валидных комбинаций
                        let defaultCoating = null;
                        let defaultThickness = null;
                        
                        // Приоритет покрытия: Зеркало, затем первое доступное
                        if (coatings.includes('Зеркало')) {
                          defaultCoating = 'Зеркало';
                        } else {
                          defaultCoating = coatings[0];
                        }
                        
                        // Приоритет толщины: x2 для выбранного покрытия, затем первая доступная
                        const thicknessesForCoating = validCombinations
                          .filter(combo => combo.coating === defaultCoating)
                          .map(combo => combo.thickness);
                        
                        if (thicknessesForCoating.includes('x2')) {
                          defaultThickness = 'x2';
                        } else if (thicknessesForCoating.length > 0) {
                          defaultThickness = thicknessesForCoating[0];
                        } else {
                          defaultThickness = thicknesses[0];
                        }
                        
                        setPipeDialog({
                          open: true,
                          type: 'round',
                          size: d,
                          coatings,
                          thicknesses,
                          defaultCoating,
                          defaultThickness,
                          validCombinations,
                        });
                        
                        // Закрываем все подменю
                        setShowPipeSubmenu(false);
                        setShowRoundSubmenu(false);
                      }}
                    >
                      Ø {d}
                    </div>
                  ))}
                </div>
              )}
              <div
                style={menuItemStyle}
                onMouseEnter={() => { 
                  setShowSquareSubmenu(true); 
                  setShowRoundSubmenu(false);
                }}
              >
                Квадратная ▶
              </div>
              {showSquareSubmenu && (
                <div
                  style={{
                    position: 'absolute',
                    top: 28,
                    left: '100%',
                    backgroundColor: 'white',
                    border: '1px solid gray',
                    borderRadius: '3px',
                    padding: '5px',
                    boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
                    minWidth: '160px',
                    zIndex: 1002,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Квадратная</div>
                  <div
                    style={menuItemStyle}
                    onMouseEnter={() => { 
                      setShowSquareProfileSubmenu(true); 
                      setShowSquareSheetSubmenu(false);
                    }}
                  >
                    Профиль ▶
                  </div>
                  {showSquareProfileSubmenu && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: '100%',
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        borderRadius: '3px',
                        padding: '5px',
                        boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
                minWidth: '10rem', // 160px
                maxHeight: '25rem', // 400px
                        overflowY: 'auto',
                        zIndex: 1003,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Профиль</div>
                      {squareProfiles.map((profile) => (
                        <div
                          key={`square-${profile}`}
                          style={{ ...menuItemStyle, position: 'relative' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const coatings = Array.from(squareProfileMap[profile]?.coating || []);
                            const thicknesses = Array.from(squareProfileMap[profile]?.thickness || []).sort((a,b)=>parseFloat(a)-parseFloat(b));
                            
                            // Формируем список валидных комбинаций из каталога
                            const validCombinations = [];
                            availableSquarePipeKeys.forEach((k) => {
                              const [, prof, thickness, coating] = k.split('|');
                              if (prof === profile && thickness && coating) {
                                validCombinations.push({ thickness, coating });
                              }
                            });
                            
                            // Определяем дефолтные значения с учетом валидных комбинаций
                            let defaultCoating = null;
                            let defaultThickness = null;
                            
                            // Приоритет покрытия: Зеркало (если есть), иначе Матовый, затем первое доступное
                            if (coatings.includes('Зеркало')) {
                              defaultCoating = 'Зеркало';
                            } else if (coatings.includes('Матовый')) {
                              defaultCoating = 'Матовый';
                            } else if (coatings.length > 0) {
                              defaultCoating = coatings[0];
                            }
                            
                            // Приоритет толщины: 2 для выбранного покрытия, затем первая доступная
                            if (defaultCoating) {
                              const thicknessesForCoating = validCombinations
                                .filter(combo => combo.coating === defaultCoating)
                                .map(combo => combo.thickness);
                              
                              if (thicknessesForCoating.includes('2')) {
                                defaultThickness = '2';
                              } else if (thicknessesForCoating.length > 0) {
                                defaultThickness = thicknessesForCoating[0];
                              }
                            }
                            
                            // Fallback если не нашли через комбинации
                            if (!defaultThickness && thicknesses.length > 0) {
                              defaultThickness = thicknesses[0];
                            }
                            
                            setPipeDialog({
                              open: true,
                              type: 'square-profile',
                              size: profile,
                              coatings,
                              thicknesses,
                              defaultCoating,
                              defaultThickness,
                              validCombinations,
                            });
                            
                            // Закрываем все подменю
                            setShowPipeSubmenu(false);
                            setShowSquareSubmenu(false);
                            setShowSquareProfileSubmenu(false);
                          }}
                        >
                          {profile}
                        </div>
                      ))}
                    </div>
                  )}
                  <div
                    style={menuItemStyle}
                    onMouseEnter={() => { 
                      setShowSquareSheetSubmenu(true); 
                      setShowSquareProfileSubmenu(false);
                    }}
                  >
                    Лист ▶
                  </div>
                  {showSquareSheetSubmenu && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 28,
                        left: '100%',
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        borderRadius: '3px',
                        padding: '5px',
                        boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
                minWidth: '10rem', // 160px
                maxHeight: '25rem', // 400px
                        overflowY: 'auto',
                        zIndex: 1003,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div style={{ padding: '0.25rem 0.5rem', fontSize: 12, color: '#666' }}>Лист</div>
                      {squareSheets.map((sheet) => (
                        <div
                          key={`square-sheet-${sheet}`}
                          style={{ ...menuItemStyle, position: 'relative' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const coatings = Array.from(squareSheetMap[sheet]?.coating || []);
                            const thicknesses = Array.from(squareSheetMap[sheet]?.thickness || []).sort((a,b)=>parseFloat(a)-parseFloat(b));
                            
                            // Формируем список валидных комбинаций из каталога
                            const validCombinations = [];
                            availableSquareSheetKeys.forEach((k) => {
                              const [, sh, thickness, coating] = k.split('|');
                              if (sh === sheet && thickness && coating) {
                                validCombinations.push({ thickness, coating });
                              }
                            });
                            
                            // Определяем дефолтные значения с учетом валидных комбинаций
                            let defaultCoating = null;
                            let defaultThickness = null;
                            
                            // Приоритет покрытия: Зеркало (если есть), иначе Матовый, затем первое доступное
                            if (coatings.includes('Зеркало')) {
                              defaultCoating = 'Зеркало';
                            } else if (coatings.includes('Матовый')) {
                              defaultCoating = 'Матовый';
                            } else if (coatings.length > 0) {
                              defaultCoating = coatings[0];
                            }
                            
                            // Приоритет толщины: 2 для выбранного покрытия, затем первая доступная
                            if (defaultCoating) {
                              const thicknessesForCoating = validCombinations
                                .filter(combo => combo.coating === defaultCoating)
                                .map(combo => combo.thickness);
                              
                              if (thicknessesForCoating.includes('2')) {
                                defaultThickness = '2';
                              } else if (thicknessesForCoating.length > 0) {
                                defaultThickness = thicknessesForCoating[0];
                              }
                            }
                            
                            // Fallback если не нашли через комбинации
                            if (!defaultThickness && thicknesses.length > 0) {
                              defaultThickness = thicknesses[0];
                            }
                            
                            setPipeDialog({
                              open: true,
                              type: 'square-sheet',
                              size: sheet,
                              coatings,
                              thicknesses,
                              defaultCoating,
                              defaultThickness,
                              validCombinations,
                            });
                            
                            // Закрываем все подменю
                            setShowPipeSubmenu(false);
                            setShowSquareSubmenu(false);
                            setShowSquareSheetSubmenu(false);
                          }}
                        >
                          {sheet}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      
      {/* Диалог выбора параметров трубы */}
      <PipeSelectionDialog
        open={pipeDialog.open}
        onClose={() => setPipeDialog({ ...pipeDialog, open: false })}
        onConfirm={({ coating, thickness }) => {
          if (pipeDialog.type === 'round') {
            if (typeof onSelectPipe === 'function') {
              onSelectPipe({ 
                objectId, 
                shape: 'round', 
                diameter: pipeDialog.size, 
                coating, 
                thickness 
              });
            }
          } else if (pipeDialog.type === 'square-profile') {
            if (typeof onSelectPipe === 'function') {
              onSelectPipe({ 
                objectId, 
                shape: 'square', 
                type: 'profile', 
                profile: pipeDialog.size, 
                coating, 
                thickness,
                displaySize: SQUARE_PROFILE_DISPLAY_SIZE[pipeDialog.size] 
              });
            }
          } else if (pipeDialog.type === 'square-sheet') {
            if (typeof onSelectPipe === 'function') {
              onSelectPipe({ 
                objectId, 
                shape: 'square', 
                type: 'sheet', 
                profile: pipeDialog.size, 
                coating, 
                thickness,
                displaySize: SQUARE_SHEET_DISPLAY_SIZE[pipeDialog.size] 
              });
            }
          }
        }}
        pipeType={pipeDialog.type}
        size={pipeDialog.size}
        availableCoatings={pipeDialog.coatings}
        availableThicknesses={pipeDialog.thicknesses}
        defaultCoating={pipeDialog.defaultCoating}
        defaultThickness={pipeDialog.defaultThickness}
        validCombinations={pipeDialog.validCombinations}
      />
    </div>
  );
};

export default ContextMenu;